export class ArrayUtil {
  static arraysEqual(a: any, b: any) {
    a = Array.isArray(a) ? a : [];
    b = Array.isArray(b) ? b : [];
    return a.length === b.length && a.every((el: any, ix: any) => el === b[ix]);
  }
}
